import { NBSP } from '../../constants';

interface IResult {
  firstRegionNames: Array<string>;
  restRegionNames: Array<string>;
}

export const splitRegionNames = (regionNames: Array<string>, maxNames: number): IResult => {
  // заменяем пробелы в строках на неразрывные,
  // чтобы составные регионы выводились на одной строке
  const regions = regionNames.map(region => region.replace(' ', NBSP));

  let firstRegionNames = regions;
  let restRegionNames: Array<string> = [];

  if (regionNames.length > maxNames) {
    firstRegionNames = regions
      // берём первые элементы массива регионов
      .slice(0, maxNames)
      // добавляем в конец пустой элемент,
      // чтобы при склейке массива в конце была запятая
      .concat(['']);

    // берём все регионы в массиве, кроме первых
    restRegionNames = regions.slice(maxNames);
  }

  return { firstRegionNames, restRegionNames };
};
